import { FirebaseConfigFetcher } from '@/features/feature-flags/FirebaseConfigFetcher';

export default defineNuxtPlugin(() => {
  FirebaseConfigFetcher.initConfig();
});
